import styled, { css } from 'styled-components/macro';

export type DropRootProps = {
  topRightRadius?: string;
  bottomRightRadius?: string;
  topLeftRadius?: string;
  bottomLeftRadius?: string;
  error?: string;
};

const disabledStyle = css`
  background-color: #0000001f;
  color: rgba(0, 0, 0, 0.38);
  cursor: default;
`;

export const DropRoot = styled.div<DropRootProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 4px 10px;
  min-height: 47px;
  width: 100%;

  padding: 0.7rem 0.875rem !important;
  border-top-right-radius: ${p => p.topRightRadius || '0.625rem'};
  border-bottom-right-radius: ${p => p.bottomRightRadius || '0.625rem'};
  border-top-left-radius: ${p => p.topLeftRadius || '0.625rem'};
  border-bottom-left-radius: ${p => p.bottomLeftRadius || '0.625rem'};
  border: ${p => p.error && '1px solid #D74545'};
  color: #454545;
`;

export const ContentContainer = styled.div<{ disabled?: boolean }>`
  width: 100%;
  background: #fff;
  box-shadow: 0px 3px 2px #00000005;
  border-width: 2px;
  border-style: solid;
  border-color: #eaeaea;
  border-radius: 10px;
  ${p => p.disabled && disabledStyle};
`;

export const FileList = styled.ul`
  margin: 0;
  padding: 0;
`;

export const FileListItem = styled.li<{ disabled?: boolean }>`
  padding: 10px 0;
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px dashed #ddd;
  ${p => p.disabled && disabledStyle};
`;
